<div class="main-content">
  <div class="container-fluid">
    <ng-container *ngFor="let item of ActionPlan; let i = index">
      <mat-accordion class="action-plan-accordion">
        <mat-expansion-panel [expanded]="step === i" (opened)="setStep(i)" class="action-plan-panel mb-4">
          <mat-expansion-panel-header class="panel-header">
            <mat-panel-title class="panel-title">
              <div class="question-container">
                <span *ngIf="En" class="question-text">{{item.question_name_en}} ?</span>
                <span *ngIf="!En" class="question-text">{{item.question_name_ar}} ?</span>
              </div>
            </mat-panel-title>
            <mat-panel-description class="panel-description">
              <div class="info-container">
                <div class="info-item">
                  <mat-icon class="info-icon">event</mat-icon>
                  <span>{{item.date | date:'yyyy-MM-dd'}}</span>
                </div>
                <div class="info-item">
                  <mat-icon class="info-icon">schedule</mat-icon>
                  <span>{{item.duedate}}</span>
                </div>
                <!-- <div class="info-item">
                  <mat-icon class="info-icon">category</mat-icon>
                  <span>{{moduleName}}</span>
                </div> -->
              </div>
              <span class="score-badge" style="background-color: #c13e33; border-radius: 5px; padding: 5px; color: white;">Score :{{item.score}}</span>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <form class="action-plan-form">
            <div class="form-section">
              <div class="question-section">
                <h3 class="section-title">
                  <mat-icon class="section-icon">help_outline</mat-icon>
                  Question
                </h3>
                <p class="question-content">
                  <span *ngIf="En" class="blockquote">{{item.question_name_en}}</span>
                  <span *ngIf="!En" class="blockquote">{{item.question_name_ar}}</span>
                </p>
              </div>

              <div class="choices-section">
                <h3 class="section-title">
                  <mat-icon class="section-icon">list</mat-icon>
                  Answered Choices
                </h3>
                <mat-list class="choices-list">
                  <ng-container *ngIf="En">
                    <mat-list-item *ngFor="let choice of item.englishansweredchoices">
                      <mat-icon matListItemIcon>check_circle</mat-icon>
                      <span matListItemTitle>{{choice}}</span>
                    </mat-list-item>
                  </ng-container>
                  <ng-container *ngIf="!En">
                    <mat-list-item *ngFor="let choice of item.arabicansweredchoices">
                      <mat-icon matListItemIcon>check_circle</mat-icon>
                      <span matListItemTitle>{{choice}}</span>
                    </mat-list-item>
                  </ng-container>
                </mat-list>
              </div>

              <div class="comment-section" *ngIf="item.comment">
                <h3 class="section-title">
                  <mat-icon class="section-icon">comment</mat-icon>
                   Auditer  Comment
                </h3>
                <p class="comment-content blockquote">{{item.comment}}</p>
              </div>

              <!-- Existing Photos Section -->
              <div class="existing-photos-section" *ngIf="item.photosurl && item.photosurl.length > 0">
                <h3 class="section-title">
                  <mat-icon class="section-icon">photo_library</mat-icon>
                  Auditer Photos
                </h3>
                <div class="images-grid">
                  <div class="image-card" *ngFor="let photo of item.photosurl">
                    <div class="image-container">
                      <img [src]="photo.url" alt="Auditer Photos" (click)="openPhoto(photo.url)">
                    </div>
                  </div>
                </div>
              </div>

             

              <div class="response-section">
                <mat-form-field appearance="outline" class="response-field">
                  <mat-label>Your Comment</mat-label>
                  <textarea matInput 
                           [(ngModel)]="item.assigneranswercomment"
                           [ngModelOptions]="{standalone: true}"
                           cdkTextareaAutosize
                           #autosize="cdkTextareaAutosize"
                           cdkAutosizeMinRows="3"
                           cdkAutosizeMaxRows="5"
                           placeholder="Enter your response here...">
                  </textarea>
                </mat-form-field>
              </div>
              <div class="upload-section">
                <div class="upload-container">
                  <button [disabled]="elementimg && elementimg.length >= 3" 
                          type="button" 
                          mat-flat-button 
                          class="upload-button" 
                          (click)="fileInput.click()">
                    <mat-icon class="mr-1">cloud_upload</mat-icon>
                    <span>Upload Photos (Max 3)</span>
                  </button>
                  <input #fileInput 
                         type="file" 
                         multiple 
                         [max]="3"
                         accept="image/*" 
                         (change)="onFileSelected($event,i)" 
                         style="display:none;" />
                </div>

                <div class="images-grid" *ngIf="element==i">
                  <div class="image-card" *ngFor="let url of elementimg let i2 = index">
                    <div class="image-container">
                      <img [src]="url.img" alt="Uploaded image">
                      <button class="remove-image" (click)="deleteimage(i2)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="action-buttons">
                <button mat-raised-button 
                        class="submit-button"
                        [disabled]="isSubmitting"
                        (click)="submit(i)">
                  <mat-icon>send</mat-icon>
                  {{ isSubmitting ? 'Submitting...' : 'Submit' }}
                </button>
                <button mat-icon-button 
                        class="translate-button" 
                        (click)="Translate()"
                        matTooltip="Toggle Language">
                  <mat-icon>translate</mat-icon>
                </button>
              </div>
            </div>
          </form>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>

    <div class="pagination-container">
      <button mat-raised-button 
              *ngIf="hasMoreData" 
              (click)="nextPage()" 
              class="load-more-button">
        <mat-icon>expand_more</mat-icon>
        See More
      </button>
    </div>
  </div>
</div>